import React, { useEffect } from 'react';
import mermaid from 'mermaid';

mermaid.initialize({
    startOnLoad: true,
    theme: 'base',
    securityLevel: 'loose',
    themeVariables: {
        fontFamily: 'Inter, sans-serif',
        primaryColor: '#3498db',
        primaryTextColor: '#fff',
        primaryBorderColor: '#2980b9',
        lineColor: '#2c3e50',
        secondaryColor: '#f39c12',
        tertiaryColor: '#fff'
    }
});

const MermaidDiagram = ({ chart }) => {
    useEffect(() => {
        mermaid.contentLoaded();
    }, [chart]);

    return (
        <div className="mermaid" style={{
            background: '#ffffff',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
            display: 'flex',
            justifyContent: 'center',
            overflowX: 'auto'
        }}>
            {chart}
        </div>
    );
};

export default MermaidDiagram;
